// a sections array in the vuex enhancedproducts store SHOULD contain all the info we need to drive the ui
export function sectionFactory(
  sectionId,
  SectionLabel,
  IsNextSectionAvailable,
  isComplete,
  sectionOptionValues,
  CallBOM,
  IsCustomSection
) {
  return {
    sectionId,
    SectionLabel,
    IsNextSectionAvailable,
    isComplete,
    sectionOptionValues,
    CallBOM,
    IsCustomSection
  };
}
